(function ($) {
  'use strict';

  /**
   * Gravity Forms Adjustments
   */

  // Hack - Disable individual select options
  // - Get options with value of `disabled`, add attr
  $(document).ready(function () {
    var $disable_options = $('.ginput_container option[value="disabled"]');

    $disable_options.each(function () {
      var $this = $(this);
      $this.prop( 'disabled', true );
    });
  });

})(jQuery);
